// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../shared/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../shared/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MultiSelectTransfer_root__HET78 {
  display: flex;
  flex-direction: column;
  gap: 20px;
  
  @media (min-width: 576px) {
    flex-direction: row;
  }
}

.MultiSelectTransfer_buttons__lMZOT {
  display: flex;
  justify-content: center;
  gap: 10px;
  

  & button {
    line-height: 1;
    height: 32px;
    width: 32px;
    padding: 4px;
    transform: rotate(90deg);
  }

  @media (min-width: 576px) {
    flex-direction: column;
    gap: 5px;

    & button {
      transform: rotate(0deg);
      width: auto;
      height: 24px;
      padding: 4px 15px;
    }
  }
}

.MultiSelectTransfer_item__5IDm4 {
  text-align: left;
  flex: 1 1;
  max-width: 100%;

  & .ant-select-dropdown {
    position: static;
    margin-top: 5px;
    box-shadow: none;
    border: 1px solid #d9d9d9;
    height: 266px;
  }

  & label {
    margin-bottom: 5px;
    display: block;
  }

  & .ant-select-dropdown-empty {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  @media (min-width: 576px) {
    flex-grow: 1;
    flex-shrink: 0;
    flex-basis: calc((100% - 87px)/2);
    max-width: calc((100% - 87px)/2);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/MultiSelectTransfer/MultiSelectTransfer.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;;EAET;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;;;EAGT;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;IACtB,QAAQ;;IAER;MACE,uBAAuB;MACvB,WAAW;MACX,YAAY;MACZ,iBAAiB;IACnB;EACF;AACF;;AAEA;EACE,gBAAgB;EAChB,SAAO;EACP,eAAe;;EAEf;IACE,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,YAA+B;IAA/B,cAA+B;IAA/B,iCAA+B;IAC/B,gCAAgC;EAClC;AACF","sourcesContent":[".root {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  \n  @media (min-width: 576px) {\n    flex-direction: row;\n  }\n}\n\n.buttons {\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n  \n\n  & button {\n    line-height: 1;\n    height: 32px;\n    width: 32px;\n    padding: 4px;\n    transform: rotate(90deg);\n  }\n\n  @media (min-width: 576px) {\n    flex-direction: column;\n    gap: 5px;\n\n    & button {\n      transform: rotate(0deg);\n      width: auto;\n      height: 24px;\n      padding: 4px 15px;\n    }\n  }\n}\n\n.item {\n  text-align: left;\n  flex: 1;\n  max-width: 100%;\n\n  & :global(.ant-select-dropdown) {\n    position: static;\n    margin-top: 5px;\n    box-shadow: none;\n    border: 1px solid #d9d9d9;\n    height: 266px;\n  }\n\n  & label {\n    margin-bottom: 5px;\n    display: block;\n  }\n\n  & :global(.ant-select-dropdown-empty) {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  @media (min-width: 576px) {\n    flex: 1 0 calc((100% - 87px)/2);\n    max-width: calc((100% - 87px)/2);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `MultiSelectTransfer_root__HET78`,
	"buttons": `MultiSelectTransfer_buttons__lMZOT`,
	"item": `MultiSelectTransfer_item__5IDm4`
};
export default ___CSS_LOADER_EXPORT___;
